import { mobile } from './constants';
window.gld_dy = {
  enabled: true,
  debug: false,
  event: async (data, props = false) => {
    return false;
    if (window.gld_dy.debug) {
      console.log('event', data);
    }
    if (window?.DY?.API && window.gld_dy.enabled && data) {
      // if data has nodeName it is HTML element
      const setData = (element) => {
        const device = element.dataset.dyEventDevice || 'all';
        const eventName = element.dataset.dyEventName || false;
        let send_event = device === 'all' ? true : false;
        if (!send_event && mobile && device === 'mobile') {
          send_event = true;
        } else if (!send_event && !mobile && device === 'desktop') {
          send_event = true;
        }
        if (send_event && eventName) {
          const properties = element.dataset.dyEventProps;
          const data_event = {
            name: eventName,
          };
          if (properties && JSON.parse(properties)) {
            data_event['properties'] = JSON.parse(properties);
          }
          return data_event;
        }
        return false;
      };
      let dataEvent = data.nodeName ? setData(data) : data;
      if (props) {
        dataEvent = { ...dataEvent, ...props };
      }
      if (window.gld_dy.debug) {
        console.log('event before send', dataEvent);
      }
      if (dataEvent) {
        // DY.API("event", dataEvent);

        if (window.DY.dyid) {
          const options = {
            method: 'POST',
            headers: {
              accept: 'text/plain',
              'content-type': 'application/json',
              'DY-API-Key':
                'fe27da30819f652c57b55e5f05abe549ccf4e519e974a192824ff480e440e171',
            },
            body: JSON.stringify({
              user: {
                dyid: window.DY.dyid,
                dyid_server: window.DY.dyid,
              },
              session: {
                dy: window.DY.jsession,
              },
              events: [dataEvent],
            }),
          };

          await fetch(
            'https://direct-collect.dy-api.com/v2/collect/user/event',
            options
          );
        }
        if (window.gld_dy.debug) {
          console.log('event sent', dataEvent);
        }
        return true;
      }
    }
    return false;
  },
  identify: (data) => {
    if (window.gld_dy.debug) {
      console.log('identify', data);
    }
    if (window?.DY?.API && window.gld_dy.enabled) {
      DY.API('identify', data);
      if (window.gld_dy.debug) {
        console.log('identify sent', data);
      }
    }
  },
};

Object.freeze(window.gld_dy);

window.gld_dy.identify({
  name: 'Identify',
  properties: {
    dyType: 'identify-v1',
  },
});
